import * as z from "zod/v4";
import { PatchCode } from "./patch-codes";

export const patchStorefrontTreatmentSchema = z.object({
  code: z.literal(PatchCode.PATCH_STOREFRONT_TREATMENT),
  teamId: z.string(),
  splitId: z.string(),
  treatmentId: z.string(),
});

export const patchStorefrontTreatment = {
  name: "patchStorefrontTreatment" as const,
  input: patchStorefrontTreatmentSchema,
  output: z.object({}),
};
